import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import FieldRepeater from '..';

const FieldRepeaterMemo = React.memo(FieldRepeater);

const FieldRepeaterCDefault = (props) => {
	const {
		name,
		minLength = 1,
		value,
		setValue,
		repeatShape = null,
		linesConvertor,
		...rest
	} = props;

	const handleAdd = useCallback(() => {
		const newValue = [...value, repeatShape];
		setValue(newValue);
	}, [value, repeatShape, setValue]);

	const handleDelete = useCallback(
		(i) => {
			const newValue = [...value];
			newValue.splice(i, 1);
			setValue(newValue);
		},
		[value, setValue],
	);

	const lines = useMemo(() => {
		return (value || []).map(linesConvertor(name));
	}, [name, linesConvertor, value]);

	return (
		<FieldRepeaterMemo
			lines={lines}
			onAdd={handleAdd}
			onDelete={handleDelete}
			deletable={value?.length > minLength}
			{...rest}
		/>
	);
};

FieldRepeaterCDefault.propTypes = {
	...FieldRepeater.propTypes,
	textError: PropTypes.string,

	// Неудаляемое кол-во линий
	minLength: PropTypes.number,

	// При добавлении новой лини этот объект используется в качестве значения по умолчанию
	repeatShape: PropTypes.any,

	/* При клике на добавить  - в массив значений добавляется новое (в соответствии с пропсом repeatShape).

		 Конвертор отвечает за преобразование объекта со значениями
		 к интерфейсу, который используется компонентом FormLine.

		 Имеет вид
		 (name) => (valueLine, index) => { return (shapeof FormLine.propTypes) }
		 Пример: FieldRepeaterCContacts
	*/
	linesConvertor: PropTypes.func.isRequired,
};

export default FieldRepeaterCDefault;
